module.exports = __webpack_public_path__ + "static/media/service-block-4@2x.b3531ec8.jpg";